import React from 'react';

import Section from '../components/Section';
import Button from '../components/Button';

const ErrorPage = ({ heading, text, siteLink, buttonText }) => {
    return (
        <>
            <main id='main' className='page-error-404'>

                <Section
                    bgColor='red'
                    className='page-error-404__main'
                >
                    <div className='container'>
                        <div className='row'>
                            <div className='col-sm-10 offset-sm-1 col-lg-8 offset-lg-2 flex'>

                                <h1 className='h1-hero white'>
                                    {heading}
                                </h1>

                                <p className='text-big desc white'>
                                    {text}
                                </p>

                                <Button
                                    href={siteLink}
                                    hover='blue'
                                    noUnderline
                                >
                                    {buttonText}
                                </Button>

                            </div>
                        </div>
                    </div>
                </Section>

            </main>
        </>
    )
}

export default ErrorPage;
